module.exports = __webpack_public_path__ + "static/media/FloatingMapLogo.dab9e695.less";